// 생성 문서 마커 [[doc:<id>:<name>]] 처리 헬퍼.
// 어시스턴트 메시지 본문 끝에 저장되는 다운로드 카드 마커 규약.

// 마커 제거(복사·저장·텍스트 표시용). 본문에서 [[doc:...]]를 지우고 과한 빈 줄 정리.
export const stripDocMarkers = (s) =>
  (s || '').replace(/\[\[doc:[^\]]+\]\]/g, '').replace(/\n{3,}/g, '\n\n').trim();

// 마커 추출 + 본문 분리. 렌더 시 다운로드 카드용 docs와 마커 제거 본문을 함께 반환.
export function extractDocMarkers(rawContent) {
  const docs = [];
  const content = (rawContent || '').replace(/\[\[doc:([^:]+):([^\]]+)\]\]/g, (_, id, name) => {
    docs.push({ id, name });
    return '';
  }).replace(/\n{3,}/g, '\n\n').replace(/\s+$/, '');
  return { docs, content };
}
